import CardVM from './../../../common/course/card/card-vm';
export default function(data) {
  var self = this;
  self.$el = $('#partner_courses');
  self.courses = ko.observableArray();
  self.shareEmails = ko.observable();

  self.bindData = function(data) {
    var mapping = {
      'courses': {
        create: function(options) {
          return new CardVM(options.data, self);
        }
      }
    };
    var mapped_courses = ko.mapping.fromJS(data, mapping);
    self.courses(mapped_courses.courses());
  };

  /*------------------------------------------------------UI----------------------------------------------------------*/
  self.initUI = function() {
    $(document).on('click', function(e) {
      self.hideOptionsMenu();
    });
    Kadenze.UIUtil.initDotDotDotTruncation();
    setTimeout(Kadenze.UIUtil.initLazyImageLoading, 300);
  };

  self.hideOptionsMenu = function($card) {
    var $menu = $('.js-course-card-options-menu', $card);
    $menu.hide();
  };

  const __construct = function(that) {
    console.log('constructor called for ShowPartnerViewModel');
    that.bindData(data);
  }(this);
}
